import {
  FiClock,
  FiCalendar,
  FiDollarSign,
  FiMapPin,
  FiBriefcase,
  FiAward,
  FiHome,
} from "react-icons/fi";
import LoginPrompt from "./LoginPrompt";
import FullButton from "../Buttons/FullButton";
import {
  Body,
  HeaderInfo,
  Section,
  Skill,
  SkillsList,
  StatusMessage,
} from "../../style/view.styles";
import {
  DeadlineIndicator,
  formatDate,
  getDaysRemaining,
  IconContainer,
  isDeadlineApproaching,
  MetadataContainer,
  MetadataContent,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
  OrganizationContainer,
} from "../../style/opportunity.details.style";

const OpportunityDetailsBody = ({
  opportunity,
  isLoggedIn,
  user,
  setIsApplyModalOpen,
  setIsCancelModalOpen,
  isApplyModalOpen,
  isCancelModalOpen,
  isApplicationSubmitted,
}) => {
  const deadlineApproaching = isDeadlineApproaching(
    opportunity.application_deadline
  );
  const daysRemaining = getDaysRemaining(opportunity.application_deadline);

  return (
    <Body>
      <HeaderInfo>
        <h1 className="font40 darkGreenColor extraBold">{opportunity.title}</h1>
        <OrganizationContainer>
          <IconContainer>
            <FiHome />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Organization</MetadataLabel>
            <MetadataValue>{opportunity.organization}</MetadataValue>
          </MetadataContent>
        </OrganizationContainer>
      </HeaderInfo>

      <MetadataContainer>
        <MetadataItem>
          <IconContainer>
            <FiBriefcase />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Employment Type</MetadataLabel>
            <MetadataValue>{opportunity.employment_type}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiMapPin />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Work Mode</MetadataLabel>
            <MetadataValue>{opportunity.work_mode}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiDollarSign />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Compensation</MetadataLabel>
            <MetadataValue>
              {opportunity.compensation || "Not specified"}
            </MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiAward />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Experience Required</MetadataLabel>
            <MetadataValue>
              {opportunity.required_years_of_experience} years
            </MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiCalendar />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Posted Date</MetadataLabel>
            <MetadataValue>{formatDate(opportunity.posted_date)}</MetadataValue>
          </MetadataContent>
        </MetadataItem>

        <MetadataItem>
          <IconContainer>
            <FiClock />
          </IconContainer>
          <MetadataContent>
            <MetadataLabel>Application Deadline</MetadataLabel>
            <MetadataValue>
              {formatDate(opportunity.application_deadline)}
            </MetadataValue>
            <DeadlineIndicator isApproaching={deadlineApproaching}>
              <FiClock />{" "}
              {daysRemaining > 0
                ? `${daysRemaining} days remaining`
                : "Deadline overdue"}
            </DeadlineIndicator>
          </MetadataContent>
        </MetadataItem>
      </MetadataContainer>

      <Section>
        <h3 className="font24 extraBold">Description</h3>
        <p className="font18" style={{ padding: "30px 0" }}>
          {opportunity.description}
        </p>
      </Section>

      <Section>
        <h3 className="font24 extraBold">Required Skills</h3>
        <SkillsList>
          {opportunity.skills_required.split(",").map((skill, index) => (
            <Skill key={index}>{skill.trim()}</Skill>
          ))}
        </SkillsList>
      </Section>

      <Section>
        {!isLoggedIn && (
          <LoginPrompt
            message="Please log in to access the application form."
            buttonText="Go To Login"
          />
        )}
        {isLoggedIn && user.role === "talent" && !isApplicationSubmitted && (
          <FullButton
            action={() => {
              setIsApplyModalOpen(!isApplyModalOpen);
            }}
            title={"Apply Here"}
          />
        )}
        {isApplicationSubmitted && (
          <StatusMessage type={"success"}>
            Application sent successfully.
          </StatusMessage>
        )}
        {isLoggedIn && user.role === "organization" && (
          <FullButton
            action={() => {
              setIsCancelModalOpen(!isCancelModalOpen);
            }}
            title={"Close"}
          />
        )}
      </Section>
    </Body>
  );
};

export default OpportunityDetailsBody;
